<div class="discovery-container">
    <div
        class="banner-container"
        style="background-image: url('./assets/images/backgrounds/cz-poster.jpg')"
    ></div>

    <div class="form-container p-l-30 p-r-30">
        <form [formGroup]="formGroup.group">
            <div class="logo">
                <img
                    src="assets/images/logo/logo-dark-bit.svg"
                    alt="Bitdefender Logo"
                    i18n-alt
                />
                <div><b>MDR</b></div>
            </div>
            <div class="info m-t-20">Login Bitdefender MDR</div>
            <div class="sub-info m-t-10">Please enter your email:</div>

            <div class="email-address-container d-flex m-t-20">
                <div class="d-flex flex-direction-column form-control">
                    <label>Email address</label>
                    <mat-form-field
                        appearance="outline"
                        class="input-form-field m-t-10"
                    >
                        <input
                            placeholder="Email"
                            i18n-placeholder
                            formControlName="email"
                            autoFocus
                            matInput
                            maxlength="255"
                            required
                            type="email"
                            name="email"
                        />
                        @if (EmailControl?.invalid && EmailControl?.touched) {
                        <button
                            matSuffix
                            mat-icon-button
                            disabled
                            class="inline-block"
                        >
                            <mat-icon class="warning-icon">warning</mat-icon>
                        </button>
                        }
                        <!-- errors -->
                        @if (EmailControl?.invalid) {
                        <mat-error>
                            <span>{{ formGroup.getReadableError('email') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>

            <div class="login-buttons-container d-flex m-t-14">
                <button
                    (click)="initiateDiscovery()"
                    *appShowSpinner="isLoading"
                    [disabled]="!formGroup.group.valid"
                    class="login-button"
                    mat-flat-button
                    color="primary"
                    type="submit"
                >
                    Next
                </button>

                @if (!isLoading) {
                <div class="or-divider"><span class="left-line"></span> OR <span class="right-line"></span></div>

                <button
                    (click)="logInWithGravityZone()"
                    [disabled]="!formGroup.group.valid"
                    class="login-button"
                    color="primary"
                    mat-stroked-button
                >
                    Log in with GravityZone
                </button>
                }
            </div>
        </form>
    </div>
</div>
